import { Component } from '@angular/core';

@Component({
  selector: 'fgb-payment-nav',
  templateUrl: './payment-nav.component.html',
  styleUrl: './payment-nav.component.scss',
})
export class PaymentNavComponent {}
